import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons'
import { Button, Icon } from '@seiue/ui'
import { FC, ReactNode } from 'react'
import styled from 'styled-components'

import { TaskHeaderLeft } from './TaskHeaderLeft'

type TaskLayoutProps = {
  /**
   * 设置 header 上的 title
   */
  title: string
  /**
   * 自定义整个 header 的内容
   */
  header?: ReactNode
  /**
   * 确定按钮的回调，不传则确定按钮不会出现
   */
  onOk?: () => void
  /**
   * 侧边栏内容
   */
  side?: ReactNode
  /**
   * 关闭按钮的回调，不传则关闭按钮不会出现
   */
  onClose?: () => void
  children?: ReactNode
  /**
   * 是否为预览模式
   */
  isPreview?: boolean
  /**
   * 确定按钮的文案
   */
  okText?: string
  HeaderRight?: React.ReactNode
}

/**
 * 任务弹窗
 *
 * @param param - 参数
 * @param param.header - 设置头
 * @param param.title - 标题
 * @param param.children - 子内容
 * @param param.side - 边框
 * @param param.onOk - 点击确定
 * @param param.onClose -点击关闭
 * @param param.isPreview - 是否预览
 * @param param.okText - 确定按钮文案
 * @returns 组件
 */
export const TaskLayout: FC<TaskLayoutProps> = ({
  header,
  title,
  children,
  side,
  onOk,
  onClose,
  isPreview,
  okText = '确定',
  HeaderRight,
}) => {
  return (
    <Wrapper>
      <HeaderContainer>
        {header ? (
          <Header>{header}</Header>
        ) : (
          <Header>
            <TaskHeaderLeft
              title={title}
              onClose={onClose}
            />
            <TaskHeaderRight>
              {HeaderRight}
              {onOk ? (
                <Button
                  type="primary"
                  onClick={onOk}
                >
                  {okText}
                </Button>
              ) : null}
            </TaskHeaderRight>
          </Header>
        )}
        {isPreview ? (
          <PreviewBanner>
            <Icon
              icon={faExclamationCircle}
              color="#ff8800"
            />
            <PreviewText>本页面为预览模式</PreviewText>
          </PreviewBanner>
        ) : null}
      </HeaderContainer>

      <Body>
        <Content className="task-layout-content">{children}</Content>
        {side ? <Side>{side}</Side> : null}
      </Body>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: #f0f5f5;

  &&& {
    .seiue-card-content {
      ::-webkit-scrollbar {
        display: none;
      }
    }
  }
`

const HeaderContainer = styled.div`
  box-shadow: 0px 0px 1px 0px rgba(21, 29, 41, 0.2),
    0px 3px 8px -1px rgba(21, 29, 41, 0.04);
  z-index: 1;
`

const Header = styled.div`
  padding: 16px 24px !important;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const PreviewBanner = styled.div`
  text-align: center;
  background-color: #fff8e8;
  padding: 9px 0;
`

const PreviewText = styled.div`
  display: inline-block;
  margin-left: 6px;
  font-size: 14px;
  line-height: 22px;
`

const Content = styled.div``

const Side = styled.div`
  margin-left: 20px;
`

const Body = styled.div`
  padding-top: 20px;
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow-y: auto;
`

const TaskHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`
